import { type HTMLArkProps, ark } from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

type TagElement = React.ElementRef<"span">;

interface TagProps extends HTMLArkProps<"span"> {
  iconClassName?: string;
  variant?: "solid" | "soft";
  size?: "sm" | "md" | "lg";
  state?: "default" | "success" | "pending" | "warning" | "info";
  icon?: React.JSX.Element;
  children: React.ReactNode;
}

const Tag = React.forwardRef<TagElement, TagProps>(
  (
    {
      className,
      iconClassName,
      icon,
      children,
      variant = "solid",
      state = "default",
      size = "sm",
      ...rest
    },
    ref,
  ) => {
    return (
      <ark.span
        data-variant={variant}
        data-state={state}
        data-size={size}
        ref={ref}
        className={clsx("ox-reset", "ox-ui-Tag", className)}
        {...rest}
      >
        {icon ? (
          <span aria-hidden className={clsx("ox-Tag-icon", iconClassName)}>
            {icon}
          </span>
        ) : null}
        {children}
      </ark.span>
    );
  },
);

Tag.displayName = "Tag";
export { Tag };
export type { TagProps };
